import { render, staticRenderFns } from "./customSecond.vue?vue&type=template&id=344f1062&scoped=true&"
import script from "./customSecond.vue?vue&type=script&lang=ts&setup=true&"
export * from "./customSecond.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./customSecond.vue?vue&type=style&index=0&id=344f1062&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344f1062",
  null
  
)

export default component.exports